import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useServiceCarStore } from '../../store/serviceCarStore';
import BookAserviceInfoModal from '../elements/bookAServiceInfoModal';
import { BookingInitButton } from '../../pages/delivery/components/BookingInitButton';
import usePersonStore from '../../store/personStore';
import { useGetDeliveryStatus } from '../../hooks/react-query/useVehicleDelivery';
import { checkBookingEnabled } from '../../utils/helper';

const CarInfoSection = ({ carData, hasDriver }) => {
  const navigate = useNavigate();

  const { setCarInfo } = useServiceCarStore();

  const { StartDate, 
    EndDate, 
    BodyType, 
    FuelType, 
    ModelName, 
    actions,
    MakeName, 
    plateno, 
    Color, 
    VIN, 
    CreditFacilityCode,
    isDeliveryEligible, 
    hasAssignedDriver,
  } = carData;

  const isBookingEnabled = checkBookingEnabled(actions);
  const showInitDeliveryButton = isDeliveryEligible === 1 && hasAssignedDriver
  const assignedRoles = usePersonStore((store) => store.userRoles);
  const userData = usePersonStore((store) => store.userData);
  const hasDriversRole = assignedRoles?.length === 1 && assignedRoles?.includes('driver');
  const hasAdminRole = userData && userData.isAdmin;

  const { data: deliveryInfo, isLoading: isDeliveryInfoLoading, } = useGetDeliveryStatus({plateno: plateno, enabled:!!hasDriversRole && !!showInitDeliveryButton})
  
  
  const deliveryType = useMemo(()=>{
    if(!!deliveryInfo?.data?.currentlyAllowed){
      return "NEW WAY"
    } else {
      if(deliveryInfo?.data?.deliveryLocation?.garageCategory === "Vehicle Delivery - Επαρχία") {
        return "RAC"
      } else if (deliveryInfo?.data?.deliveryLocation?.garageCategory === "Vehicle Delivery - Dealers") {
        return "AUTHORIZED"
      } else {
        return null
      }
    }
  },[deliveryInfo])

  return (
    <div className="flex flex-col gap-6 py-3 px-6">
      <div className="flex justify-between">
        <h4>{MakeName}</h4>
        {hasDriversRole && !isDeliveryInfoLoading && showInitDeliveryButton && ((deliveryType === "NEW WAY" && deliveryInfo?.data?.currentlyAllowed === true) || ["AUTHORIZED","RAC"].includes(deliveryType))
          ? !deliveryInfo?.data?.currentlyScheduled && <BookingInitButton disabled={false} carInfo={carData} deliveryInfo={deliveryInfo?.data}/> 
          // ? false && <BookingInitButton disabled={false} carInfo={selectedCar} deliveryType={deliveryInfo?.data?.deliveryLocation?.garageName}/> 
          : isDeliveryEligible === 0 && (isBookingEnabled
          ? (<button
              disabled={!plateno && !hasAdminRole}
              onClick={() => {
                navigate('/service-booking');
                setCarInfo(carData);
              }}
              className="btn-secondary text-secondary-button "
            >
              Ραντεβού Service
            </button>
          ) : <BookAserviceInfoModal />)
        }
        {/* {isDeliveryEligible === 0 && (!!hasDriver ? (
          <button
            type="button"
            className="btn-secondary text-secondary-button"
            onClick={() => {
              navigate('/service-booking');
              setCarInfo(carData);
            }}
          >
            Ραντεβού Service
          </button>
        ) : (
          <BookAserviceInfoModal />
        ))} */}
      </div>
      <div className="flex flex-wrap gap-8">
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Τύπος Καυσίμου</span>
          <span className="body-text">{FuelType}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Τύπος Αυτοκινήτου</span>
          <span className="body-text">{BodyType}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Αριθμός Πινακίδας</span>
          <span className="body-text">{plateno}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Έναρξη Συμβολαίου</span>
          <span className="body-text">{StartDate.split('-')[2] +'/'+ StartDate.split('-')[1] +'/'+ StartDate.split('-')[0]}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">Λήξη Συμβολαίου</span>
          <span className="body-text">{EndDate.split('-')[2] +'/'+ EndDate.split('-')[1] +'/'+ EndDate.split('-')[0]}</span>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">
          Χρώμα
          </span>
          <div className="body-text">{Color}</div>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">
          VIN
          </span>
          <div className="body-text">{VIN}</div>
        </div>
        <div className="flex flex-col">
          <span className="text-label text-fadedgrey">
          Αριθμός παραρτήματος
          </span>
          <div className="body-text">{CreditFacilityCode}</div>
        </div>
      </div>
    </div>
  );
};

export default CarInfoSection;
